<template>
  <div>
    <label v-if="label">
      <StrongText :color="color">{{ label }}</StrongText>
    </label>
    <FormElementStyle>
      <input
        :type="type"
        :value="value"
        :placeholder="placeholder"
        :disabled="disabled"
        @keydown="$emit('keydown', $event.target.value)"
        @input="$emit('input', $event.target.value)"
        />
    </FormElementStyle>
  </div>
</template>

<script>
import FormElementStyle from '@/components/FormElementStyle'
import StrongText from '@/components/StrongText'

export default {
  name: 'Input',
  props: {
    disabled: {
      default: false
    },
    label: String,
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    color: {
      required: false
    }
  },
  components: {
    StrongText,
    FormElementStyle,
  }
}
</script>

<style lang="scss" scoped>
input[disabled='disabled'] {
  background: #e2e2e2;
  color: #8e8e8e;
}
input {
  color: #003862;
}
</style>
